import { render, staticRenderFns } from "./AddOrgType.vue?vue&type=template&id=34b23cd0"
import script from "./AddOrgType.vue?vue&type=script&lang=js"
export * from "./AddOrgType.vue?vue&type=script&lang=js"
import style0 from "./AddOrgType.vue?vue&type=style&index=0&id=34b23cd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports